import React, { ReactElement, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hook.ts"
import { colors } from "../../../ui/colors.ts"
import { ArrowLeftIcon } from "../../../ui/icons/arrowLeftIcon.tsx"
import { SettingIcon } from "../../../ui/icons/settingIcon.tsx"
import { LayoutComponent } from "../../../ui/layout/index.tsx"
import { ButtonComponent } from "../../../ui/molecules/button/index.tsx"
import { ErrorPopup } from "../../../ui/organisms/errorPopup/index.tsx"
import { HorizontalTab } from "../../../ui/organisms/horizontalTab/index.tsx"
import { MenuItems } from "../../../ui/organisms/sidebar/dto.ts"
import { SuccessPopup } from "../../../ui/organisms/successPopup/index.tsx"
import { Tab } from "../../../ui/organisms/tab/index.tsx"
import { Availability } from "./availability.tsx"
import { setAvailabilities, setSelectedDuration, setSettingTab, setUpdateAvailabilitesFinancialAdvisorStatus, updateAvailabilitesFinancialAdvisor } from "./slice.ts"

export function Settings() {
    const navigation = useNavigate()
    const dispatch = useAppDispatch()

    const financialAdvisorState = useAppSelector(state => state.financialAdvisor)
    const appointmentsState = useAppSelector(state => state.appointments)
    const authState = useAppSelector(state => state.auth)

    useEffect(() => {
        if (authState.findMeFinancialAdvisorStatus === "successfully" && authState.findMeFinancialAdvisorResponse?.availabilities !== null) {
            dispatch(setAvailabilities(authState.findMeFinancialAdvisorResponse?.availabilities))
            dispatch(setSelectedDuration(authState.findMeFinancialAdvisorResponse?.duration))
        }
    }, [authState.findMeFinancialAdvisorStatus, authState.findMeFinancialAdvisorResponse])

    const viewComponentMap = new Map<number, ReactElement>([
        [0, <Availability />],
    ])

    return (
        <LayoutComponent
            menuItem={MenuItems.APPOINTMENTS}
            headingLabel={"Impostazioni"}
            headingButtons={[
                <>
                    <ButtonComponent
                        label={"Torna agli appuntamenti"}
                        onClick={() => navigation('/appointments')}
                        color={"gray"}
                        variant={"outline"}
                        size={"md"}
                        iconPosition={"left"}
                        icon={<ArrowLeftIcon size={"24"} color={colors.neutral[500]} />}
                    />
                    <ButtonComponent
                        size={"md"}
                        iconPosition={"off"}
                        variant={"solid"}
                        color={"blue"}
                        label={"Aggiorna"}
                        onClick={() => dispatch(updateAvailabilitesFinancialAdvisor({ id: authState.findMeFinancialAdvisorResponse?.id!, request: appointmentsState.availabilityFinancialAdvisorRequest }))}
                        disabled={(appointmentsState.availabilityFinancialAdvisorRequest.availabilities !== null &&
                            appointmentsState.availabilityFinancialAdvisorRequest.availabilities.length > 0 &&
                            appointmentsState.availabilityFinancialAdvisorRequest.availabilities
                                .filter(item => item.times.filter(elem => (!elem.startTime.trim() || !elem.endTime.trim())).length > 0)
                                .length > 0)}
                    />
                </>
            ]}
            breadcrumbItems={['Appuntamenti', 'Impostazioni']}
            breadcrumbIcon={<SettingIcon color={colors.brandSecondary[500]} size={"20"} />}
        >
            <SuccessPopup
                active={appointmentsState.availabilityFinancialAdvisorStatus === "successfully"}
                close={() => dispatch(setUpdateAvailabilitesFinancialAdvisorStatus("idle"))}
                message="Disponibilità aggiornate correttamente."
            />
            <ErrorPopup
                active={appointmentsState.availabilityFinancialAdvisorStatus === "failed"}
                close={() => dispatch(setUpdateAvailabilitesFinancialAdvisorStatus("idle"))}
                message="Errore durante l'aggiornamento delle disponibilità. Riprova."
            />
            <HorizontalTab>
                <Tab
                    label={"Disponibilità"}
                    selectedPrimary={appointmentsState.settingTab === 0}
                    onClick={() => dispatch(setSettingTab(0))}
                    type="primary"
                />
            </HorizontalTab>
            {viewComponentMap.get(appointmentsState.settingTab)}
        </LayoutComponent >
    )
}